module.exports = __webpack_public_path__ + "small_blue_icons_fullwidthwpee94b44df9d05f7e52fb938d6a6439e2.png";